import { useContext } from 'react'

import { FlowLoggerContext } from './FlowLoggerContext'

export const useFlowLogger = () => {
  const flowLogger = useContext(FlowLoggerContext)
  if (!flowLogger) {
    throw new Error('You must render this element inside a <FlowLoggerProvider> element')
  }
  return flowLogger
}
